/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var NProgress = require('nprogress');

var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');

var GetEntity = require('../services/GetEntity');
var GetEntityExamsByEntity = require('../services/GetEntityExamsByEntity');
var GetEntityHCExamsByEntity = require('../services/GetEntityHCExamsByEntity');
var GetEntityLegalHoldStatus = require('../services/GetEntityLegalHoldStatus');

var DepIntEntityDashboardView = require('../views/DepIntEntityDashboardView');

module.exports = function(entityId) {
  NProgress.start();
  NProgress.set(0.6);

  $.when(
    GetEntity(entityId),
    GetEntityLegalHoldStatus(entityId),
    GetEntityExamsByEntity(entityId),
    GetEntityHCExamsByEntity(entityId)
  )
    .done(function(entity, hasLegalHold, exams, hcExams) {
      NavUtils.navigate('#dep/entity/' + entityId + '/dashboard');
      Scaffold.content.show(
        new DepIntEntityDashboardView({
          viewMode: 'int',
          model: new Backbone.Model({ entity: entity, hasLegalHold: hasLegalHold, exams: exams, hcExams: hcExams })
        })
      );
      NProgress.done();
    })
    .fail(function(err) {
      NProgress.done();
    });
};
